import { createContext, useContext, useEffect, useMemo, useState, type FC } from 'react';
import { Appointment } from 'types';

type Context = {
    appointment: Appointment;
    setAppointment: React.Dispatch<React.SetStateAction<Appointment>>;
};

export const defaultAppointmentContext: Context = {
    appointment: {} as Appointment,
    setAppointment: () => {}
};

export const AppointmentContext = createContext<Context>(defaultAppointmentContext);

export const useAppointmentContext = () => useContext(AppointmentContext);

export const AppointmentContextProvider: FC<{ value?: Appointment }> = ({ value, children }) => {
    const [appointment, setAppointment] = useState<Appointment>(value ?? ({} as Appointment));
    const appointmentContext = useMemo(() => ({ appointment, setAppointment }), [appointment]);

    useEffect(() => {
        value && setAppointment(value);
    }, [value]);

    return <AppointmentContext.Provider value={appointmentContext}>{children}</AppointmentContext.Provider>;
};
